define.alias("shared/helpers/rebase-indexed-number", "settings/helpers/rebase-indexed-number");